import { useState, useEffect } from "react";
import Api from "../functions/Api";
import { ValidationResponse } from "../functions/validation";

const useClient = ({ handleMuestraSnack, setBotonSigDisabled }) => {
  const [clientes, setClientes] = useState([]);
  const [direccion, setDireccion] = useState([]);
  const [modalNuevoCliente, setModalNuevoCliente] = useState(false);
  const usuario = localStorage.getItem("user") || "{}";
  const [ejecutaapi] = Api();
  const [column] = useState([
    { title: "ID Cliente", field: "ID_CLIENTE", type: "numeric", editable: "never" },
    { title: "Nombre", field: "NOMBRES", type: "string" },
    { title: "Apellido Paterno", field: "APELLIDO_PATERNO", type: "string" },
    { title: "Apellido Materno", field: "APELLIDO_MATERNO", type: "string" },
    { title: "Fecha Nacimiento", field: "FECHA_NACIMIENTO", type: "date", editable: "never" },
    { title: "Clave Elector", field: "CLAVE_ELECTOR", type: "string", editable: "never" }
  ]);
  const [selectedRow, setSelectedRow] = useState();

  useEffect(() => {
    const nuevoClienteId = sessionStorage.getItem("nuevo_cliente_id");
    if (nuevoClienteId) {
      sessionStorage.removeItem("nuevo_cliente_id");
      const body = JSON.stringify({
        idCliente: parseInt(nuevoClienteId),
        nombre: "", apellidoP: "", apellidoM: "", claveElector: "",
        usuario: JSON.parse(usuario).email
      });
      ejecutaapi("obtienecliente", body).then(data => {
        const { result } = ValidationResponse(data);
        if (result && result.length > 0) {
          setClientes(result);
          handleMuestraSnack && handleMuestraSnack("Cliente cargado automaticamente", "success");
        }
      });
    }
  }, []); // eslint-disable-line

  const onRowClick = (e, clickedRow) => {
    setSelectedRow(clickedRow);
    handleSearchDireccionCliente(clickedRow);
  };

  const handleSearchDireccionCliente = cliente => {
    const body = JSON.stringify({
      idPersona: cliente.ID_PERSONA,
      usuario: JSON.parse(usuario).email
    });
    ejecutaapi("obtienedireccioncliente", body).then(data => {
      const { result, error } = ValidationResponse(data);
      if (error !== "") handleMuestraSnack && handleMuestraSnack(error, "error");
      if (result && result.length > 0) {
        setDireccion(result);
        setBotonSigDisabled(false);
      } else {
        handleMuestraSnack && handleMuestraSnack(
          "El cliente seleccionado aun no tiene registrada una direccion", "error"
        );
        setBotonSigDisabled(true);
      }
    });
  };

  const handleSearchClient = formulario => {
    const body = JSON.stringify({
      idCliente: formulario.numeroCliente > 0 ? formulario.numeroCliente : 0,
      nombre: formulario.nombres,
      apellidoP: formulario.apellidoP,
      apellidoM: formulario.apellidoM,
      claveElector: formulario.claveElector || "",
      usuario: JSON.parse(usuario).email
    });
    ejecutaapi("obtienecliente", body).then(data => {
      const { result, error } = ValidationResponse(data);
      if (error !== "") handleMuestraSnack && handleMuestraSnack(error, "error");
      if (result && result.length > 0) {
        setClientes(result);
      } else {
        setClientes([]);
        handleMuestraSnack && handleMuestraSnack("No se encontraron clientes con esos criterios", "warning");
      }
    });
  };

  return {
    selectedRow, column, clientes, onRowClick,
    handleSearchClient, direccion, modalNuevoCliente, setModalNuevoCliente
  };
};

export default useClient;
